import { kimchiPremiumRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const kimchiPremiumRoute: RouteObject = {
  path: kimchiPremiumRoutePaths.kimchiPremium.path,
  async lazy() {
    const KimchiPremiumPage = await import('@/pages/kimchi-premium/KimchiPremium');
    return { Component: KimchiPremiumPage.default };
  },
};

export const kimchiPremiumDayRoute: RouteObject = {
  path: kimchiPremiumRoutePaths.kimchiPremiumDay.path,
  async lazy() {
    const Page = await import('@/pages/kimchi-premium/DailyPage');
    return { Component: Page.default };
  },
};
